import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { NewStyleColor, BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';
import UserAgentUtils from '../../../utils/userAgent';

interface WrapperProps {
	isDisplayed: boolean;
}

interface ToggleProps {
	isExpanded: boolean;
}

const Wrapper = styled('div')`
	position: absolute;
	bottom: 0;
	right: 0;
	z-index: 10;
	width: 320px;
	border-radius: 9px 9px 0 0;
	background-color: ${NewStyleColor.White};
	box-shadow: 0 2px 26px 0 ${hexToRgba(NewStyleColor.Black, 25)};
	color: ${NewStyleColor.Black};
	transform: ${(props: WrapperProps) => props.isDisplayed ? 'translateY(0)' : 'translateY(150%)'};
	transition: transform 600ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`;

const StyledHeader = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	height: 40px;
	padding: 20px;
	padding-right: 15px;
	border-radius: inherit;
	background-color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};

	> span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

const Title = styled(Translate)`
	font-family: HelveticaNeue, sans-serif;
	font-size: 13px;
	line-height: 20px;
	color: ${NewStyleColor.White};
`;

const ErrorBadge = styled('div')`
	width: 5px;
	height: 5px;
	margin: 0 10px;
	border-radius: 50%;
	background-color: ${NewStyleColor.Red300};
`;

const buttonCommonStyles = `
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px;
	border: 0;
	outline: 0;
	background-color: transparent;
	cursor: pointer;

	svg {
		fill: ${NewStyleColor.White};
	}
`;

const Toggle = styled('button')`
	${buttonCommonStyles}
	margin-left: auto;

	${({ isExpanded }: ToggleProps) => !isExpanded && 'transform: rotate(180deg);'}

	svg {
		width: 11px;
		height: 11px;
	}
`;

const ButtonClose = styled('button')`
	${buttonCommonStyles}

	svg {
		width: 9px;
		height: 9px;
	}
`;

const StyledSubHeader = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 32px;
	padding: 10px 20px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 16px;
`;

const ButtonCancelAll = styled('button')`
	margin-left: auto;
	padding: 0;
	border: 0;
	outline: 0;
	background-color: transparent;
	font-family: HelveticaNeue, sans-serif;
	font-size: 8px;
	line-height: 12px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	text-transform: uppercase;
	letter-spacing: 1.1px;
	cursor: pointer;
`;

const StyledList = styled('ul')`
	max-height: 250px;
	margin: 0;
	padding: 0;
	list-style-type: none;
	overflow-y: auto;

	${() => !UserAgentUtils.isMobileApp && `
		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-track {
			background-color: ${NewStyleColor.White};
		}

		&::-webkit-scrollbar-thumb {
			border-left: 2px solid ${NewStyleColor.Grey400};
			background-color: ${NewStyleColor.White};
		}
	`}
`;

const StyledListItem = styled('li')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	height: 50px;
	padding: 15px 20px;
	border-top: 1px solid ${NewStyleColor.Grey300};
	font-size: 12px;
	line-height: 16px;
`;

const FileIcon = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		width: 16px;
		height: 16px;
		fill: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	}
`;

const FileLabel = styled('div')`
	margin: 0 10px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const FileStatus = styled('div')`
	display: flex;
	align-items: center;
	margin-left: auto;
`;

const StatusDone = styled('div')`
	position: relative;
	left: 1px;

	svg {
		width: 22px;
		height: 22px;
		fill: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	}
`;

const StatusError = styled('div')`
	display: flex;
	align-items: center;
	font-size: 8px;
	color: ${NewStyleColor.Red300};
	text-transform: uppercase;

	svg {
		width: 20px;
		height: 20px;
		margin-left: 8px;
		fill: currentColor;
	}
`;

const ButtonRestart = styled('button')`
	${buttonCommonStyles}

	margin-left: auto;
	padding: 0;
	font-size: 8px;
	line-height: 20px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	text-transform: uppercase;

	span {
		position: relative;
		top: 1px;
	}

	svg {
		width: 20px;
		height: 20px;
		margin-left: 8px;
		fill: currentColor;
	}
`;

const ButtonFileCancel = styled('button')`
	${buttonCommonStyles}

	width: 20px;
	height: 20px;
	margin-left: 13px;
	padding: 0;
	border-radius: 50%;
	background-color: ${NewStyleColor.Red300};

	svg {
		width: 8px;
		height: 8px;
	}
`;

export {
	Wrapper,
	StyledHeader,
	Title,
	ErrorBadge,
	Toggle,
	ButtonClose,
	StyledSubHeader,
	ButtonCancelAll,
	StyledList,
	StyledListItem,
	FileIcon,
	FileLabel,
	FileStatus,
	StatusDone,
	StatusError,
	ButtonRestart,
	ButtonFileCancel,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/Toast/styles.ts